import React from 'react';
import './inputLabel.scss';

const InputLabel=({ label, tooltip, tabIndex, showTooltip, required })=>{
  return (
    <div className="input-label-wrapper">
      <span className="input-label cust-info-question">{label} {required && <span className="required-asterisk">*</span>}</span>
      {
        showTooltip?<div className="tooltip-container" tabIndex={tabIndex}>
          <span className="input-label-info-icon standard-blue">&#9432;</span>
          <span className="tooltip-item">{tooltip}</span>
        </div>:null
      }
    </div>
  );
};

export default InputLabel;
